export const mapAdditionalDetailsToEventDetails = (additionalDetailIds?: string[]) =>
  additionalDetailIds?.map((additionalDetailId) => ({
    event_details_id: { id: Number.parseInt(additionalDetailId, 10) },
  }));
